import { render } from "./bookReadingClub.vue?vue&type=template&id=87eaa626"
import script from "./bookReadingClub.vue?vue&type=script&lang=js"
export * from "./bookReadingClub.vue?vue&type=script&lang=js"

import "./bookReadingClub.vue?vue&type=style&index=0&id=87eaa626&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__